import Backbone from 'backbone'

var User = Backbone.Model.extend({

	domainType: 'user',

	url: function() {
		const {id, editable, groupEditable} = this.attributes
		if (!editable && groupEditable) { // #25363
			return `api/admin/users/${id}/groups`
		}
		return Backbone.Model.prototype.url.apply(this, arguments)
	},

	urlRoot: function(options) {
		return 'api/admin/users'
	}

})

export default User

User.__filename__ = 'admin/principals/users/user.js'
